var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-6"},[_c('div',{staticClass:"d-flex p-3"},[_c('v-skeleton-loader',{staticClass:"mx-2",attrs:{"type":"table-cell@3"}})],1),_c('v-skeleton-loader',{attrs:{"type":"list-item"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }